<template>
	<div style="width: 100%;height: 100%;overflow: auto;">
	  <div :id="randomId" style="width:100%; height:100%;"></div>
	</div>
</template>
<script>
  import solelyEchartsJs from './solely-echarts.js'
  export default solelyEchartsJs
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/echarts/solely-echarts.vue